import { isFailure } from "@sportal/api";
import { DrilldownSlice } from "@sportal/api/reports";

import { SBThunkAction } from "../../../redux.types";
import {
  LOAD_TABLE,
  LOAD_TABLE_FAILURE,
  LOAD_TABLE_SUCCESS,
  TableActionTypes,
} from "./table.types";
import {
  DrilldownDataKeys,
  ReportsPeriod,
} from "../../../../helpers/reports.helper.types";
import { fetchReport } from "../../reports.actions";

export const loadTableReports =
  (
    endpoint: DrilldownDataKeys,
    options: { period: ReportsPeriod; profile: string; limit?: number }
  ): SBThunkAction<void, TableActionTypes> =>
  (dispatch) => {
    dispatch(
      async () => {
        const id = endpoint;
        const { period, profile, limit } = options;
        dispatch(loadTable({ id, period, profile }));

        const config = {
          period,
          limit,
          withGranularity: true,
          ...(profile !== "all_profiles" && { profile }),
        };

        const result = await dispatch(
          fetchReport(endpoint, config, "getDrilldowns"),
          {
            showLoader: false,
          }
        );

        if (isFailure(result)) {
          dispatch(
            loadTableFailure({
              id,
              error: result.error,
              period,
              profile,
            })
          );
          return;
        }

        dispatch(
          loadTableSuccess({
            id,
            data: result.data,
            period,
            profile,
          })
        );
      },
      { showLoader: false }
    );
  };

const loadTable = ({
  id,
  period,
  profile,
}: {
  id: DrilldownDataKeys;
  period: ReportsPeriod;
  profile: string;
}): TableActionTypes => ({
  type: LOAD_TABLE,
  payload: {
    id,
    period,
    profile,
  },
});

const loadTableSuccess = ({
  id,
  data,
  period,
  profile,
}: {
  id: DrilldownDataKeys;
  data: DrilldownSlice[];
  period: ReportsPeriod;
  profile: string;
}): TableActionTypes => ({
  type: LOAD_TABLE_SUCCESS,
  payload: {
    id,
    data,
    period,
    profile,
  },
});

const loadTableFailure = ({
  id,
  error,
  period,
  profile,
}: {
  id: DrilldownDataKeys;
  error: any;
  period: ReportsPeriod;
  profile: string;
}): TableActionTypes => ({
  type: LOAD_TABLE_FAILURE,
  payload: {
    id,
    error,
    period,
    profile,
  },
});
